<template>
  <div>
    Authorizing...
  </div>
</template>
